import { UserPropertyType } from '@gettactic/api';
import { SelectTeams } from '../SelectTeams';

interface TeamAttendanceFiltersProps {
  teams: string[];
  onTeamsChange: (ids: string[]) => void;
  onSaveFilterData: (type: UserPropertyType, value: string) => void;
  isComponentLoading?: boolean;
}

export const TeamAttendanceFilters = ({
  teams,
  onTeamsChange,
  isComponentLoading
}: TeamAttendanceFiltersProps) => {
  return (
    <div className="">
      <div className="">
        <SelectTeams
          includeFavs={true}
          teams={teams}
          applyOnClick={true}
          onChange={(teamIds: string[] | string) => {
            const teamIdsArray = Array.isArray(teamIds) ? teamIds : [teamIds];
            onTeamsChange(teamIdsArray);
          }}
          className=""
          disabled={isComponentLoading}
          triggerClassName="mx-0 px-0 py-0 my-0 min-h-0 text-nowrap h-auto"
        />
      </div>
    </div>
  );
};
